import { Component } from '@angular/core';

@Component({
  selector: 'app-main-layout-monitor',
  templateUrl: './main-layout-monitor.component.html',
  styleUrls: ['./main-layout-monitor.component.scss'],
})
export class MainLayoutMonitorComponent {}
